<template lang="pug">
  div
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    transition(name='fade')
      .content.article(v-if="!loading")
        .grid
          .col-4_xs-12.titles
            h2.h-l
              | learn
            router-link(:to="{ name: 'blog'}")
              h3.h-sm.category
                | 600state
            h1.h-xl(v-html="title")
            .author-date
              h4.h-md.author
                | {{ author }}
              h4.h-md.date
                | {{ date }}
            h4.h-sm.share(@click="share=!share")
              | share
              transition(name='fade')
                social(v-if="share" :meta="shareInfo")
          .col-8_xs-12
            .hero
              img.cover(:src="hero.url" :alt="heroCaption")
            p.heroCaptions.body-captions(v-if="captions" v-html="captions")
          .col-5_xs-12(data-push-left="off-4_xs-0" v-if="hero.url")
            .copy.wysiwyg(v-html="text")
          .col-4_xs-12.related(v-if="relatedExhibitions.length > 0")
            h2.h-l
              | related exhibitions
          .col-8_xs-12.related(v-if="relatedExhibitions.length > 0")
            .grid.no-margin
              .col-5_xs-12.details(v-for="exhibition in relatedExhibitions" data-push-right="off-1")
                router-link(:to="{name: 'exhibition-single', params: {year: year(exhibition), id: exhibition.uid }}")
                  h3.h-m
                    | {{ exhibition.content.title }}
                  h4.h-sm
                    | {{ exhibition.content.teaser }}
                  p.h-sxx
                    | {{ relatedExhibitionDate(exhibition) }}
                  .col-4.related
          .col-4_xs-12.related(v-if="relatedArticles.length > 0")
            h2.h-l
              | related articles
          .col-8_xs-12.related(v-if="relatedArticles.length > 0")
            .grid.no-margin
              .col-5_xs-12.details(v-for="article in relatedArticles" data-push-right="off-1")
                router-link(:to="{name: 'article', params: {article: article.uid }}")
                  h3.h-m(v-html="checkTitle(article)")
                  h4.h-sm
                    | {{ article.content.teaser }}
                  .col-4.related
    bottom-nav(footerColor="white")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'article',
  mixins: [DataMixin, ComponentMixin],

  data () {
    return {
      share: false
    }
  },

  mounted () {
    this.requestData(this.key, 'article')
  },

  computed: {
    key: function () {
      let path = this.$route.path.substring(1).split('/')
      path.splice(2, 1)
      return path.join('/')
    },

    content: function () {
      return this.loadedData[this.key].content
    },

    files: function () {
      return this.loadedData[this.key].files
    },

    title: function () {
      return this.content.title
    },

    hero: function () {
      const name = this.content.main_image
      return this.files.find(item => item.filename === name)
    },

    heroCaption: function () {
      return this.hero.meta.caption
    },

    captions: function () {
      let captionString = ''
      if (this.hero) {
        const caption = this.hero.meta.caption
        const credit = this.hero.meta.credit

        if (caption) {
          captionString += caption + '. '
        }
        if (credit) {
          captionString += credit + '.'
        }

        return captionString
      } else {
        return false
      }
    },

    text: function () {
      return this.content.text
    },

    author: function () {
      return this.content.author
    },

    date: function () {
      return this.content.date
    },

    relatedArticles: function () {
      if (this.loadedData[this.key].related_articles) {
        return this.loadedData[this.key].related_articles
      }
      return []
    },

    relatedExhibitions: function () {
      if (this.loadedData[this.key].related_exhibitions) {
        return this.loadedData[this.key].related_exhibitions
      }
      return []
    },

    shareInfo: function () {
      const data = {
        // url: this.loadedData[this.key].url,
        url: window.location.href,
        title: this.title,
        description: this.text,
        image: this.hero.url
      }
      return data
    }
  },

  methods: {
    checkTitle: function (post) {
      if (post.content.short_title) {
        if (post.content.short_title.length > 0) {
          return post.content.short_title
        } else {
          return post.content.title
        }
      } else {
        return post.content.title
      }
    },

    relatedExhibitionDate: function (ex) {
      let start = ''

      if (ex.content.start_year !== ex.content.end_year) {
        start = ex.content.start_date + ', ' + ex.content.start_year
      } else {
        start = ex.content.start_date
      }
      const end = ex.content.end_date + ', ' + ex.content.end_year
      return start + ' - ' + end
    },

    year: function (exhibition) {
      return exhibition.content.start_year
    }
  },

  watch: {
    $route: function () {
      this.requestData(this.key, 'article')
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/_mixins'
  @import '../styles/_variables'
  .article
    padding-top: 0
    @include respond-to(xs)
      padding-top: 0rem
    .titles
      margin-top: 0
      @include respond-to(xs)
        margin-top: 0rem
      h1
        padding-top: 4rem
        @include respond-to(xs)
          padding-top: 2rem
      ul
        margin-top: 4rem
        @include respond-to(xs)
          margin-top: 0rem
      h3
        color: rgb(104, 204, 232)
        margin-bottom: 0.5rem
      .author-date
        margin-top: 2.5rem
      .share
        margin-top: 2rem
        cursor: pointer
        color: #939598
    .hero
      width: 100%
      height: 47.5vw
      @include respond-to(xs)
        height: 72vw
    .heroCaptions
      margin-top: 1rem
      color: #939598
    .related
      margin-top: 4rem
      h3, h4, a
        padding: 0
        margin: 0
      h3
        padding-top: 0.4rem
        padding-left: 0
      .details
        margin-top: 2px
        a
          &:hover h3
            border-bottom: solid 2px #000
        h3
          display: inline
          border-bottom: solid 2px #FFF
</style>



// WEBPACK FOOTER //
// Article.vue?10e8870c